import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { lazyReducerEnhancer } from 'pwa-helpers/lazy-reducer-enhancer.js';
import apiMiddleware from '../api/store/middleware/api';
import site from '../site/store/reducer';
import account from '../account/store/reducer';
import user from '../user/store/reducer';
import app from '../app/store/reducer';
import routing from '../routing/store/reducer';
import notification from '../notification/store/reducer';
import videoService from '../video-service/store/reducer';
import { useReduxDevTools, getDevCompose } from './devtool-helpers';
const devCompose = useReduxDevTools() ? getDevCompose() : compose;

// Initializes the Redux store with a lazyReducerEnhancer (so that you can
// lazily add reducers after the store has been created) and redux-thunk (so
// that you can dispatch async actions). See the "Redux and state management"
// section of the wiki for more details:
// https://pwa-starter-kit.polymer-project.org/redux-and-state-management
export const store = createStore(
    (state) => state,
    devCompose(lazyReducerEnhancer(combineReducers), applyMiddleware(apiMiddleware, thunk))
);

// Initially loaded reducers, note we could lazy load in modules, might be nice to create module.addReducer(store)
// and then we would need less syntax here. (or better addReducer(module) which would look for module.constant.name and module.reducer)
// todo routing
// store.addReducers({
//     [routing.constants.NAME]: routing.reducer,
//     [app.constants.NAME]: app.reducer,
//     [user.constants.NAME]: user.reducer,
//     [site.constants.NAME]: site.reducer,
// });

store.addReducers({
    routing,
    app,
    notification,
    account,
    site,
    user,
    videoService,
});
